import {AxiosResponse} from 'axios'

import Client from 'core/api/client'


/**
 * Represents a single study participant's informational data, as seen by a study coordinator.
 */
export interface IStudyReviewerResult {
  id: string
  firstName: string
  lastName: string
  email: string
  npi: string
  isApproved: boolean
  approvedTime: string
  isAdmin: boolean
  createdTime: string
  isTechnician: boolean
  technicianNPIs: string[] | null
}

/**
 * Expected response body from GET /study/participants endpoint
 */
interface IGetReviewersResponseBody {
  studyReviewers: { [key: string]: IStudyReviewerResult }
}

/**
 * Expected response from GET /study/participants endpoint
 */
export interface IGetReviewersResponse extends AxiosResponse {
  data: IGetReviewersResponseBody
}

interface IGetReviewerResponseBody {
  studyReviewer: IStudyReviewerResult
}

/**
 * Represents the response for the GET /study/reviewer endpoint
 */
export interface IGetReviewerResponse extends AxiosResponse {
  data: IGetReviewerResponseBody
}

/**
 * GET /study/participants
 */
export function getReviewers(token: string): Promise<IGetReviewersResponse> {
  const headers = { Authorization: `Bearer ${token}` }
  return Client.get('/study/reviewers', { headers, validateStatus: () => true })
}

export function getReviewer(token: string): Promise<IGetReviewerResponse> {
  const headers = { Authorization: `Bearer ${token}` }
  return Client.get('/study/reviewer', { headers, validateStatus: () => true })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/getStudyReviewer.ts